import React from 'react'
import { useValues, useActions } from 'kea'
import I18n from 'lib/i18n'

import sceneLogic from './logic'

import Tabs from './tabs'
import Pagination from './pagination'
import TeacherSlides from './teachers-slides'
import StudentSlides from './students-slides'
import Reputation from './reputation'

import './styles.scss'

export default function How () {
  const { setUserType, prevSlide, nextSlide, setSlideIndex } = useActions(sceneLogic)
  const { slideIndex, userType } = useValues(sceneLogic)

  return (
    <div className='content-page how-page'>
      <div className='row'>
        <div className='twelve columns'>
          <h2>{I18n.t('pages.how1.title')}</h2>
        </div>
      </div>
      <div className='row'>
        <div className='twelve columns'>
          <div className='widget noborder slider-box content-box clearfix'>
            <Tabs currentTab={userType} setUserType={setUserType} />
            <Pagination
              slideIndex={slideIndex}
              prevSlide={prevSlide}
              nextSlide={nextSlide}
              setSlideIndex={setSlideIndex}
            />
            {userType === 'teachers' && <TeacherSlides slideIndex={slideIndex} />}
            {userType === 'students' && <StudentSlides slideIndex={slideIndex} />}
          </div>
        </div>
      </div>
      {userType === 'teachers' && <Reputation />}
    </div>
  )
}
